import './Skeleton.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  className?: string
}

export function Skeleton({ width, height = 20, borderRadius = 6, className }: SkeletonProps) {
  return (
    <div
      className={`skeleton ${className || ''}`}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
      }}
    />
  )
}

export function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <Skeleton width={48} height={48} borderRadius="50%" />
      <div className="skeleton-content">
        <Skeleton width="60%" height={16} />
        <Skeleton width="40%" height={14} />
      </div>
    </div>
  )
}

export function SkeletonStatCard() {
  return (
    <div className="skeleton-stat-card">
      <Skeleton width={48} height={48} borderRadius={12} />
      <div className="skeleton-stat-content">
        <Skeleton width={60} height={28} />
        <Skeleton width={80} height={14} />
      </div>
    </div>
  )
}

export function SkeletonTable({ rows = 5 }: { rows?: number }) {
  return (
    <div className="skeleton-table">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton-table-row">
          <Skeleton width={40} height={40} borderRadius="50%" />
          <Skeleton width="30%" height={16} />
          <Skeleton width="20%" height={14} />
          <Skeleton width={80} height={28} borderRadius={6} />
          <Skeleton width={60} height={28} borderRadius={6} />
        </div>
      ))}
    </div>
  )
}
